const CAPTURE_ERROR_REASON_PATTERNS = Object.freeze([
  ['shiny_capture_cap_reached', 'shiny-cap'],
  ['high_iv_capture_cap_reached', 'high-iv-cap'],
  ['capture_cap_reached', 'capture-cap'],
]);

/** Maps server-domain capture failures to UI-safe result reasons. */
export function captureErrorReason(error) {
  const message = [
    error?.message,
    error?.details,
    error?.hint,
    error?.code,
    error,
  ].filter(Boolean).join(' ').toLowerCase();
  return CAPTURE_ERROR_REASON_PATTERNS.find(([needle]) => message.includes(needle))?.[1]
    || 'sync-failed';
}

/** Returns the i18n key for a capture result's failure state. */
export function captureFailureMessageKey(reason) {
  switch (reason) {
    case 'no-ball':
      return 'capture.noBall';
    case 'capture-cap':
      return 'capture.capReached';
    case 'shiny-cap':
      return 'capture.shinyCapReached';
    case 'high-iv-cap':
      return 'capture.highIvCapReached';
    case 'sync-failed':
      return 'sys.syncFail';
    default:
      return 'capture.autoEscaped';
  }
}
